import { render, staticRenderFns } from "./jiuyetongji.vue?vue&type=template&id=42bf2282&scoped=true"
import script from "./jiuyetongji.vue?vue&type=script&lang=js"
export * from "./jiuyetongji.vue?vue&type=script&lang=js"
import style0 from "./jiuyetongji.vue?vue&type=style&index=0&id=42bf2282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf2282",
  null
  
)

export default component.exports